export const NAMESPACE = "HealthPassAddAssignmentModal";

export const DROPDOWN_FIELD_ID = "addAssignmentModalTypes";
